import { computed } from 'mobx';
import actionSelector from '../../SaleWizard/stores/actionSelector';

const config =
  require(`../../../@${process.env.REACT_APP_TENANT}/config.js`).default;

export default class CommandBarStore {
  constructor({ root }) {
    this.sale = root;
  }

  @computed get isMls() {
    return this.sale.isMls;
  }

  @computed get agentData() {
    return this.sale.saleEdit.agentData;
  }

  @computed get hasSalePermissions() {
    return this.sale.hasSalePermissions;
  }

  @computed get hasOfferPermissions() {
    return this.sale.hasOfferPermissions;
  }

  @computed get hasExclusiveOfferPermissions() {
    return this.sale.hasExclusiveOfferPermissions;
  }

  // sale permissions
  @computed get saleEditEnabled() {
    return (
      !this.sale.isDeleted && !this.sale.isClosed && this.hasSalePermissions
    );
  }

  @computed get inviteSellerEnabled() {
    return (
      !this.sale.isDeleted && !this.sale.isClosed && this.hasSalePermissions
    );
  }

  @computed get inviteBuyerAgentEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.hasSalePermissions &&
      this.isMls
    );
  }

  // sale permissions
  @computed get saleCloseEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      !this.sale.round.isOpen &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get saleDeleteEnabled() {
    return (
      (this.sale.isClosed ||
        (!this.sale.isDeleted &&
          !this.sale.round.isOpen &&
          !this.sale.round.isClosed) ||
        (config.allowDeleteEmptySale &&
          this.sale.offers.viewModel.offers.length === 0)) &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get whitelistingEnabled() {
    return (
      !this.sale.isDeleted && !this.sale.isClosed && this.hasSalePermissions
    );
  }

  @computed get whitelistingVisible() {
    return this.sale.inviteOnly;
  }

  // sale permissions
  @computed get roundStartEnabled() {
    return (
      this.sale.isComplete &&
      !!this.sale.round.definition &&
      this.sale.round.definition.canStart &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get roundEditEnabled() {
    return (
      !!this.sale.round.definition &&
      this.sale.round.definition.canEdit &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get roundOpenEnabled() {
    return (
      !!this.sale.round.definition &&
      this.sale.round.definition.canOpen &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get roundCloseEnabled() {
    return (
      !!this.sale.round.definition &&
      this.sale.round.definition.canClose &&
      this.hasSalePermissions
    );
  }

  // none
  @computed get userRegistrationEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isOpen &&
      (this.hasOfferPermissions || this.isMls) &&
      this.sale.round.type !== 'counteroffer_bidding'
    );
  }

  // sale permissions
  @computed get userBlockingEnabled() {
    return (
      !this.registrationEnabled &&
      !this.sale.isDeleted &&
      this.sale.offers.isOfferSelected &&
      !this.sale.offers.selectedOffer.buyerIsBlocked &&
      (this.hasExclusiveOfferPermissions || this.hasSalePermissions)
    );
  }

  // sale permissions
  @computed get registrationEnabled() {
    var offer = this.sale.offers.selectedOffer;
    return (
      offer &&
      (offer.status === 'registrationConfirmed' ||
        offer.status === 'registrationSubmitted') &&
      this.hasSalePermissions
    );
  }

  // ??
  @computed get offerUploadEnabled() {
    var res =
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isOpen &&
      !this.sale.offers.isOfferSelected;

    return (
      (res ||
        this.offerUploadExistingEnabled ||
        this.isIncreaseBidInOpenRound) &&
      (this.hasOfferPermissions ||
        (!this.sale.offers.isOfferSelected && this.isMls))
    );
  }

  // ??
  @computed get offerUploadExistingEnabled() {
    const res =
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isOpen &&
      this.sale.offers.isOfferSelected &&
      !this.sale.offers.selectedOffer.buyerIsBlocked; //&&
    // (this.sale.offers.selectedOffer.status === 'invited' ||
    //   this.sale.offers.selectedOffer.status === 'submitted' ||
    //   this.sale.offers.selectedOffer.status === 'refused' ||
    //   this.sale.offers.selectedOffer.status === 'accepted');
    return res;
  }

  // ??
  @computed get isIncreaseBidInOpenRound() {
    const res =
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isOpen &&
      this.sale.round.isOpenBidding &&
      this.sale.offers.isOfferSelected &&
      (this.sale.offers.selectedOffer.status === 'confirmed' ||
        this.sale.offers.selectedOffer.status === 'accepted' ||
        (this.sale.offers.selectedOffer.status === 'submitted' &&
          this.sale.offers.selectedOffer.isValid));
    return res;
  }

  @computed get offerApproveEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canApprove &&
      this.hasSalePermissions
    );
  }

  // offer permissions
  @computed get offerRefuseEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      !this.sale.round.isClosed &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canRefuse &&
      this.hasExclusiveOfferPermissions
    );
  }

  // sale permissions
  @computed get offerAwardEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isClosed &&
      !this.sale.offers.hasWinner &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canAward &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get offerAcceptEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isClosed &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canAccept &&
      this.hasSalePermissions
    );
  }

  // sale permissions
  @computed get offerRejectEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isClosed &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canReject &&
      this.hasSalePermissions
    );
  }

  // offer permissions
  @computed get offerConfirmOnBehalfEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.round.isOpen &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.canConfirmOnBehalf &&
      this.hasOfferPermissions
    );
  }

  // offer exclusive permissions
  @computed get offerPreviewEnabled() {
    return (
      !this.sale.isDeleted &&
      this.sale.offers.isOfferSelected &&
      this.sale.offers.selectedOffer.isValid &&
      !['invited', 'submitted', 'refused'].some(
        (s) => s === this.sale.offers.selectedOffer.status
      ) &&
      this.hasExclusiveOfferPermissions
    );
  }

  @computed get updateContactEnabled() {
    return (
      !this.sale.isDeleted &&
      !this.sale.isClosed &&
      this.sale.offers.isOfferSelected &&
      this.hasOfferPermissions
    );
  }

  @computed get saleWizardEnabled() {
    // const { round } = this.sale;
    const hasSelector =
      actionSelector({ sale: this.sale, round: this.sale.round.definition })
        .length > 0;
    return hasSelector; //;|| (round.isSimpleOffer && round.isOpen);
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/CommandBarStore.js